import md from "./markdown.js";
import dedent from "dedent";

function renderSlotForLocale(slots, locale) {
  if (slots.default) {
    var slot = slotForLocale(slots, locale);
    var source = dedent(slot.children[0].text);
    if (slot) return md.render(source);
    else
      console.warn(
        "[Extra Component] At least one <pre> tag with markdown content is required."
      );
    return "";
  } else {
    console.warn(
      "[Extra Component] At least one <pre> tag with markdown content is required."
    );
    return "";
  }
}

// Get contents of the first child tag, which should be <pre> tag,
// To preserve formatting from vue-template-compiler
function slotForLocale(slots, locale) {
  return (
    (slots.default &&
      slots.default.find(s => {
        return s.tag === "pre" && s.data.attrs[locale] !== undefined;
      })) ||
    // Fallback to the first <pre> tag, if pre for locale was not found
    (slots.default &&
      slots.default.find(s => {
        return s.tag === "pre";
      }))
  );
}

export { slotForLocale, renderSlotForLocale };
